export default __webpack_public_path__ + "static/media/sagir.17f4f9a9.jpg";